import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { server } from "../../server";

function Right() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [stream, setStream] = useState(null);
  const token = localStorage.getItem("authToken");
  const [searchResults, setSearchResults] = useState([]);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    } catch (err) {
      console.error("Error accessing camera:", err);
      alert("Camera access denied. Please allow camera permissions.");
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || video.readyState < 2) {
      toast.info("Please Wait, Starting Camera", { autoClose: 2000 });
      return;
    }

    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const imageDataUrl = canvas.toDataURL("image/jpeg");
    setCapturedImage(imageDataUrl);

    canvas.toBlob(async (blob) => {
      const file = new File([blob], "selfie.jpg", { type: "image/jpeg" });

      // Show persistent toast
      const toastId = toast.loading("Uploading Selfie, Please Wait");

      try {
        await uploadAndSearch(file);
        toast.update(toastId, {
          render: "Selfie Uploaded",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } catch (err) {
        toast.update(toastId, {
          render: "Something Went Wrong",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    }, "image/jpeg");
  };

  useEffect(() => {
    const modalEl = document.getElementById("scanModal");

    const handleShown = () => {
      startCamera();
    };
    const handleHidden = () => {
      stopCamera();
      setCapturedImage(null);
    };

    if (modalEl) {
      modalEl.addEventListener("shown.bs.modal", handleShown);
      modalEl.addEventListener("hidden.bs.modal", handleHidden);
    }

    return () => {
      if (modalEl) {
        modalEl.removeEventListener("shown.bs.modal", handleShown);
        modalEl.removeEventListener("hidden.bs.modal", handleHidden);
      }
    };
  }, [stream]);

  const uploadAndSearch = async (file) => {
    try {
      const fileName = `selfie-${Date.now()}.jpg`;
      const presignedRes = await fetch(
        `${server}/PresignedUrl/GeneratePresignedUrl`,
        {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: JSON.stringify({
            folder: "search",
            fileNames: [fileName],
          }),
        },
      );

      const presignedData = await presignedRes.json();
      const uploadDetails = presignedData.urls[0];
      const s3Key = uploadDetails.imageKey;

      // Step 2: Upload the file to S3
      await fetch(uploadDetails.signedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": uploadDetails.contentType,
        },
        body: file,
      });

      // Step 3: Call SearchFace API with the correct key
      const searchRes = await fetch(`${server}/Search/SearchFace`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          key: s3Key,
          eventId: "68cfa9d2fdaeef346e951661",
        }),
      });

      const searchData = await searchRes.json();

      if (searchData.images && searchData.images.length > 0) {
        const closeButton = document.querySelector(
          "#scanModal .btn-close-modal",
        );
        if (closeButton) closeButton.click();
        setSearchResults(searchData.images);
      } else {
        toast.info("No Matches Found");
      }
    } catch (err) {
      toast.error("Something Went Wrong");
    }
  };

  return (
    <div>
      <div className="bg-red p-4 pb-7 rounded-4 d-flex justify-content-center align-items-center flex-column mt-2">
        <div class="d-flex align-items-center flex-column py-3">
          <div className="d-flex">
            <Link
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#scanModal"
              className="action-button-lg bg-white-transparent rounded-circle mb-2"
            >
              <i className="bi bi-camera fs-3 text-dark"></i>
            </Link>
          </div>
          <div>
            <h4 class="mb-0 mt-3 normal-text lh-1 text-center">
              <a href="#" class="text-light opacity-75">
                Capture / Upload Image
              </a>
            </h4>
            <p class="m-0 fs-6 text-center text-white opacity-50 lh-1 mt-1">
              Just one photo unlocks all your event memories.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-green p-4 pt-0 rounded-4 d-flex justify-content-center align-items-center flex-column mt-2 mb-3">
        <div class="d-flex align-items-center flex-column pb-2">
          <div className="">
            <div className="d-flex justify-content-center">
              <div className="bg-white rounded-3 p-2 mb-3 mt-n6">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/10401/10401171.png"
                  width="50"
                />
              </div>
            </div>
            <h4 class="mb-0 normal-text lh-1 text-center">
              <a href="#" class="text-light opacity-75">
                Download Mobile App
              </a>
            </h4>
            <p class="m-0 fs-6 text-center text-white opacity-75 lh-1 mt-1">
              Download the Visualaey app on iOS & Android.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-3 rounded-4 d-flex flex-column mb-5">
        <div class="d-flex align-items-center">
          <div className="d-flex">
            <span className="action-button-lg bg-dark-transparent rounded-circle">
              <i className="bi bi-headset fs-3 text-white"></i>
            </span>
          </div>
          <div className="ms-3">
            <h4 class="mb-0 normal-text lh-sm">
              <a href="#" class="text-dark">
                24/7 Support
              </a>
            </h4>
            <p class="m-0 fs-6 text-dark lh-1 mt-1">
              Send Email to - <a href="mailto:support@visualaey.com">support@visualaey.com</a>
            </p>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="scanModal"
        tabIndex="-1"
        aria-labelledby="scanModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-body pt-3 pb-2">
              <h4 className="mb-0 mt-3 normal-text lh-1 text-center">
                <span className="text-dark ls-sm fs-4">
                  Find Your Photos Instantly
                </span>
              </h4>
              <p className="m-0 fs-5 ls-sm text-center text-dark opacity-75 lh-1 mt-2">
                Upload a selfie to instantly see every event photo
                <br />
                you’re in—no tags, no search.
              </p>

              <div className="d-flex flex-column align-items-center justify-content-center mt-4">
                {!capturedImage ? (
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    width="180"
                    height="180"
                    className="object-fit-cover rounded-circle bg-dark"
                  />
                ) : (
                  <img
                    src={capturedImage}
                    width="180"
                    height="180"
                    className="object-fit-cover rounded-circle"
                    alt="Captured Selfie"
                  />
                )}

                <canvas ref={canvasRef} style={{ display: "none" }} />

                <button
                  className="btn btn-dark-primary border-0 px-5 rounded-3 fs-6 fw-medium mt-4"
                  onClick={capturePhoto}
                  disabled={!stream}
                >
                  <i className="bi bi-camera me-1"></i> Upload Selfie
                </button>
              </div>
            </div>
            <div className="modal-footer border-0 p-0">
              <button
                type="button"
                className="btn btn-success rounded-circle px-3 label-text text-white btn-close-modal me-n3 mb-n2"
                data-bs-dismiss="modal"
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Right;
